import { ScrollSectionId } from 'types/types'
import aboutUsSectionImage from 'images/aboutUsSection/aboutUsImage.webp'

export const aboutUsSectionData = {
  imageSrs: {
    height: 675,
    src: aboutUsSectionImage,
    width: 675,
  },
  buttonSrc: {
    role: 'button',
    id: ScrollSectionId.Portfolio,
  },
}
